import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import CardCollection from '@/components/card/CardCollection';
import ListBarMarket from '@/components/list-bar/ListBarMarket';
import NoData from '@/components/NoData';
import RenderWhen from '@/components/RenderWhen';
import { useRouter } from '@/provider/RouterProvider';

import { CategoryKey } from '../Trending/constants';
import CollectionSkeletion from './Skeleton';
import useCollection from './useCollection';

const MarketCollection = () => {
  const [openFilter, setOpenFilter] = useState(false);
  const searchParam = useSearchParams();
  const router = useRouter();
  const { list, loading, loadMore, currentPage } = useCollection();
  const hasClearAll = searchParam.has('name') || searchParam.has('createdAt');

  const handleClearFilter = () => {
    setOpenFilter(false);
    router.push(
      `/marketplace?category=${CategoryKey.collection}`,
      { scroll: false },
      { noLoadBar: true },
    );
  };
  return (
    <div className="px-[40px] md:px-[20px]">
      <div className="mt-4">
        <ListBarMarket
          handleClearFilter={handleClearFilter}
          setOpenFilter={setOpenFilter}
          openFilter={openFilter}
          hasHotTag={false}
          searchPlaceholder="Search in Collections"
          hasClearAll={hasClearAll}
          hasFilter={false}
          sortArtwork={false}
          sortCollection
        />
      </div>
      <div className="py-10 lg:h-[100%] lg:py-5">
        <div className="flex w-full">
          <div className="w-full aria-expanded:w-[calc(100%-320px)] aria-expanded:duration-300 md:!w-full">
            <RenderWhen>
              <RenderWhen.If isTrue={list?.length === 0 && loading}>
                <CollectionSkeletion />
              </RenderWhen.If>
              <RenderWhen.If isTrue={list?.length > 0}>
                <InfiniteScroll
                  style={{ overflow: 'hidden' }}
                  dataLength={list?.length}
                  next={() => {
                    loadMore(currentPage + 1);
                  }}
                  hasMore
                  loader=""
                >
                  <div className="grid grid-cols-5 gap-5 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 sm:grid-cols-1">
                    {list.map((item) => (
                      <CardCollection
                        key={item.id}
                        image={item.thumbnail || item.picture}
                        tradingVolume={item.tradingVolume}
                        name={item.name}
                        totalItem={item.numberOfItems}
                        collectionId={item.id}
                        className="!mb-0"
                      />
                    ))}
                  </div>
                </InfiniteScroll>
              </RenderWhen.If>
              <RenderWhen.If isTrue={list.length === 0 && !loading}>
                <NoData />
              </RenderWhen.If>
            </RenderWhen>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketCollection;
